import { MouseEvent, useCallback, useContext } from 'react';
import { ConfirmModal, ModalProviderContext } from 'ui';
import { TrashGrayIcon } from 'ui/icons';

interface IssuerOperationArchiveButtonProps {
  id: number;
  entityName: string;
  onArchive: (id: number) => Promise<unknown>;
}

export const IssuerOperationArchiveButton = ({
  id,
  entityName,
  onArchive,
}: IssuerOperationArchiveButtonProps) => {
  const { openModal } = useContext(ModalProviderContext);

  const handleArchive = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      openModal(ConfirmModal, {
        title: `Archive ${entityName}?`,
        onConfirm: async () => {
          await onArchive(id);
        },
      });
    },
    [entityName, id, onArchive, openModal],
  );

  return (
    <button
      type="button"
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded hover:bg-gray-100"
      onClick={handleArchive}
      aria-label={`Archive ${entityName}`}
      title={`Archive ${entityName}`}
    >
      <img src={TrashGrayIcon} alt="Archive" className="h-5 w-5" />
    </button>
  );
};
